/**
 * Configuration centralisée pour la gestion du cache de l'application
 */

/**
 * Clés localStorage à préserver lors du nettoyage
 * (préférences utilisateur qui doivent survivre aux changements de session)
 */
export const PRESERVED_STORAGE_KEYS = [
  // Thème
  'theme',
  'sphere-theme',
  'vite-ui-theme',
  'dark-mode',
  'color-scheme',
  // Contexte établissement (doit persister pendant la session)
  'sphere:activeEstablishmentId',
  'sphere:activeAcademicYear',
  'admin-context-storage',
] as const;

/**
 * Configuration React Query pour le bootstrap
 */
export const BOOTSTRAP_CACHE_CONFIG = {
  /**
   * Durée avant que les données soient considérées comme périmées (ms)
   * 60s = correspond au TTL du cache backend
   */
  staleTime: 60_000,

  /**
   * Durée de conservation en mémoire après désactivation (ms)
   * 5min = garde les données en cache pour une navigation fluide
   */
  gcTime: 5 * 60 * 1000,

  /**
   * Nombre de tentatives en cas d'échec
   */
  retry: 3,

  /**
   * Comportement au montage du composant
   * false = utilise le cache si les données sont fresh
   */
  refetchOnMount: false,

  /**
   * Refetch quand la fenêtre reprend le focus
   */
  refetchOnWindowFocus: false,

  /**
   * Refetch en cas de reconnexion réseau
   */
  refetchOnReconnect: true,
} as const;

/**
 * Clé de flag pour détecter un changement de session Keycloak
 */
export const SESSION_CHANGED_FLAG = 'keycloak-session-changed';
